// extracted by mini-css-extract-plugin
export default {"icons":"DealsFilters_icons__pFIK5","selected-icons":"DealsFilters_selected-icons__BrabK","add-icon":"DealsFilters_add-icon__JRiEg"};